













































































































































































































import {
  defineComponent,
  ref
} from '@vue/composition-api'
import {
  TcTextInput,
  TcButton,
  TcDropdown,
  TcFieldset,
  TcSelectionButton,
  TcTextArea
} from '@telia/shared-ui-components'
import useVuelidate, { ValidationArgs } from '@vuelidate/core'
import {
  helpers,
  maxLength,
  minLength,
  numeric,
  required
} from '@vuelidate/validators'
import { MAX_DEFAULT_ATTACHMENT_SIZE } from '@/constants/file-picker'

import AnslFilePicker from '@/components/common/form_v2/AnslFilePicker.vue'
import AnslSpinner from '@/components/LoadingSpinner.vue'

import {
  attachmentSizeValidator,
  emailValidator,
  phoneNumberValidator,
  scrollToInvalidFieldV2,
  swedishCharactersValidator
} from '@/utils/validation.utils'
import {
  getValidationMessage,
  getValidationState
} from '@/utils/form.utils'

import {
  ContactFormPageCaseReason,
  ContactFormRequest,
  PreferredContactFormEnum,
  Properties,
  VALIDATION_MESSAGES,
  ACCEPTABLE_FILE_EXTENSIONS
} from '@/types/contact-form-page.types'

const INPUT_FIELD_LENGTH = 150
const DESCRIPTION_INPUT_FIELD_LENGTH = 2500
const DROPDOWN_PLACEHOLDER = {
  value: '',
  label: '\u00A0'
}

export default defineComponent({
  components: {
    TcTextInput,
    TcButton,
    TcDropdown,
    TcTextArea,
    TcFieldset,
    TcSelectionButton,
    AnslSpinner,
    AnslFilePicker
  },
  emits: ['formSubmitted'],
  props: {
    contactFormContent: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    requesterName: {
      type: String,
      required: true
    },
    personalIdentityNumber: {
      type: String,
      required: true
    }
  },
  setup (props, context) {
    const caseReasonDropdownOptions: ContactFormPageCaseReason[] = [DROPDOWN_PLACEHOLDER]
      .concat(...props.contactFormContent.caseReasons || [])

    const caseReason = ref('')
    const description = ref('')
    const attachments = ref<File[]>([])
    const streetAddress = ref('')
    const zipCode = ref('')
    const city = ref('')
    const phoneNumber = ref('')
    const emailAddress = ref('')
    const preferredContactForm = ref<PreferredContactFormEnum>(PreferredContactFormEnum.Email)

    const phoneNumberRequiredValidator = (value: string) => !(preferredContactForm.value === PreferredContactFormEnum.Phone && !value)

    const validationArgument = {
      caseReason: {
        required: helpers.withMessage(VALIDATION_MESSAGES[Properties.CaseReason], required)
      },
      description: {
        required: helpers.withMessage(VALIDATION_MESSAGES[Properties.Description], required)
      },
      attachments: {
        attachmentSizeValidator: {
          $message: VALIDATION_MESSAGES[Properties.Attachments],
          $validator: attachmentSizeValidator()
        }
      },
      streetAddress: {
        required: helpers.withMessage(VALIDATION_MESSAGES[Properties.StreetAddress], required)
      },
      zipCode: {
        required: helpers.withMessage(VALIDATION_MESSAGES[Properties.ZipCode], required),
        numeric: helpers.withMessage(VALIDATION_MESSAGES[Properties.ZipCode], numeric),
        minLength: helpers.withMessage(VALIDATION_MESSAGES[Properties.ZipCode], minLength(5)),
        maxLength: helpers.withMessage(VALIDATION_MESSAGES[Properties.ZipCode], maxLength(5))
      },
      city: {
        required: helpers.withMessage(VALIDATION_MESSAGES[Properties.City], required),
        swedishCharactersValidator: {
          $validator: swedishCharactersValidator,
          $message: VALIDATION_MESSAGES[Properties.City]
        }
      },
      phoneNumber: {
        requiredIf: {
          $validator: phoneNumberRequiredValidator,
          $message: VALIDATION_MESSAGES[Properties.PhoneNumber]
        },
        phoneNumberValidator: {
          $validator: phoneNumberValidator,
          $message: VALIDATION_MESSAGES[Properties.PhoneNumber]
        }
      },
      emailAddress: {
        required: helpers.withMessage(VALIDATION_MESSAGES[Properties.EmailAddress], required),
        email: {
          $validator: emailValidator,
          $message: VALIDATION_MESSAGES[Properties.EmailAddress]
        },
        minLength: helpers.withMessage(VALIDATION_MESSAGES[Properties.EmailAddress], minLength(5)),
        maxLength: helpers.withMessage(VALIDATION_MESSAGES[Properties.EmailAddress], maxLength(100))
      },
      preferredContactForm: {}
    } as ValidationArgs

    const $v = useVuelidate(validationArgument,
      {
        caseReason,
        description,
        attachments,
        streetAddress,
        zipCode,
        city,
        phoneNumber,
        emailAddress,
        preferredContactForm
      }
    )

    const onSubmit = () => {
      $v.value.$touch()
      const formErrors = $v.value.$errors

      if (formErrors.length) {
        scrollToInvalidFieldV2(context, formErrors)
      } else {
        context.emit('formSubmitted', {
          fullName: props.requesterName,
          personalIdentityNumber: props.personalIdentityNumber,
          caseReason: caseReason.value,
          description: description.value,
          attachments: attachments.value,
          streetAddress: streetAddress.value,
          zipCode: zipCode.value,
          city: city.value,
          phoneNumber: phoneNumber.value,
          emailAddress: emailAddress.value.toLocaleLowerCase(),
          preferredContactForm: preferredContactForm.value
        } as ContactFormRequest)
      }
    }

    return {
      ACCEPTABLE_FILE_EXTENSIONS,
      INPUT_FIELD_LENGTH,
      DESCRIPTION_INPUT_FIELD_LENGTH,
      MAX_DEFAULT_ATTACHMENT_SIZE,

      caseReasonDropdownOptions,

      PreferredContactFormEnum,

      caseReason,
      description,
      attachments,
      streetAddress,
      zipCode,
      city,
      phoneNumber,
      emailAddress,
      preferredContactForm,

      onSubmit,

      getValidationState,
      getValidationMessage,
      $v
    }
  }
})
